import Link from 'next/link';
import React from 'react';
import DefaultWidthContainer from '../../Layout/Containers/DefaultWidthContainer';
import ImageAndTextContainer from '../../Layout/Containers/ImageAndTextContainer/ImageAndTextContainer';
import TripleColumnContainer from '../../Layout/Containers/TripleColumnContainer';
import ContactBannerComponent from '../../util/ContactComponent/ContactBannerComponent';
import PageHeaderComponent from '../../util/PageHeader/PageHeaderComponent';
import CustomersInsurance from '../Customers/CustomersInsuranceComponent';
import styles from './insurancePage.module.scss';
import BreadcrumbsComponent from '../../Breadcrumbs/BreadcrumbsComponent';

const crumbs = [
    {
        url: '/solutions',
        name: 'Solutions',
    },
    {
        url: '/solutions/insurance-software',
        name: 'Insurance Software',
    },
];

const InsurancePageComponent = () => (
    <>
        <DefaultWidthContainer>
            <BreadcrumbsComponent crumbs={crumbs} />
        </DefaultWidthContainer>
        <PageHeaderComponent
            extraStyles={{ paddingTop: '40px' }}
            quote="Noria’s end-to-end insurance solutions is deployable on-premise or in the Cloud. Marine insurers, industry insurers, captives and brokers value our dedication to their needs, continuous investment in product development, and in-depth domain competence."
        >
            <h1>Noria Insurance Software</h1>
        </PageHeaderComponent>
        <TripleColumnContainer>
            <h3 className={styles.offeringsHeader}>Our offerings</h3>
            <div className={styles.offeringsContainer}>
                <div className={styles.offeringContainer}>
                    <h4>Core Platform</h4>
                    <p>
                        Enjoy streamlined processes and seamless integration with other systems with
                        our solutions’ integrated business modules.
                    </p>
                    <Link
                        href="/solutions/offerings#core-platform"
                        title="Go to the core platform section of our offerings page for more information"
                    >
                        <span>Read more &#10132;</span>
                    </Link>
                </div>
                <div className={styles.offeringContainer}>
                    <h4>Self Service</h4>
                    <p>
                        The ideal solution to extend service capacity when you need to deliver 24/7
                        to your customers.
                    </p>
                    <Link
                        href="/solutions/offerings#self-service"
                        title="Go to the self service section of our offerings page for more information"
                    >
                        <span>Read more &#10132;</span>
                    </Link>
                </div>
                <div className={styles.offeringContainer}>
                    <h4>Insight</h4>
                    <p>
                        Turn data into insights. Noria Insight solution helps you to better
                        structure, utilise your data, and transform your business.
                    </p>
                    <Link
                        href="/solutions/insight"
                        title="Go to the Insight page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
                <div className={styles.offeringContainer}>
                    <h4>Cloud Operations</h4>
                    <p>
                        Noria is your certified cloud partner. We help you with everything from
                        hosting your applications in the cloud to managing your IT needs and
                        security concerns.
                    </p>
                    <p>You can focus on your core business while we take care of the rest.</p>
                    <Link
                        href="/services/cloud-operations"
                        title="Go to the Cloud Operations page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
                <div className={styles.offeringContainer}>
                    <h4>Customer Centric Platform</h4>
                    <p>
                        Our Customer Centric Platform enables you to leverage your collected
                        customer data proactively and lessens your dependency on external resources.
                        Customer insights will always be at your fingertips.
                    </p>
                    <Link
                        href="/solutions/customer-centric-platform"
                        title="Go to the Customer Centric Platform page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
                <div className={styles.offeringContainer}>
                    <h4>Tailored Portals</h4>
                    <p>We offer portals to tailor your needs, delivered in a matter of weeks.</p>
                    <Link
                        href="/solutions/offerings#tailored-portals"
                        title="Go to the tailored portals section of our offerings page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
            </div>
        </TripleColumnContainer>
        <TripleColumnContainer>
            <h3 className={styles.header}>Why choose Noria Insurance Software</h3>
            <div className={styles.benefitsContainer}>
                <div className={styles.benefitContainer}>
                    <h4>Insurance Companies & Agencies</h4>
                    <p>
                        Noria solutions are highly configurable and customisable, no matter how
                        specialised your requirements are. The system's in-built flexibility means
                        special lines can be created with ease to suit your business needs.
                    </p>
                    <Link
                        href="/solutions/insurance/benefits#insurance-companies-and-agencies"
                        title="Go to the insurance companies and agencies section of our benefits page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
                <div className={styles.benefitContainer}>
                    <h4>Marine & Energy</h4>
                    <p>
                        Gain efficiency, self-service, business agility in a single source of data
                        entry and automatic workflow.
                    </p>
                    <Link
                        href="/solutions/insurance/benefits#marine-and-energy"
                        title="Go to the marine and energy section of our benefits page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
                <div className={styles.benefitContainer}>
                    <h4>Captive Insurance</h4>
                    <p>
                        A single solution for your business processes, comprehensive customer care,
                        and a powerful and user-friendly claims web portal.
                    </p>
                    <Link
                        href="/solutions/insurance/benefits#captive-insurance"
                        title="Go to the captive insurance section of our benefits page for more information"
                    >
                        <span>Read more</span>
                    </Link>
                </div>
            </div>
            <Link href="/solutions/insurance/benefits" className={styles.benefitsLink}>
                <span>See all the benefits</span>
            </Link>
        </TripleColumnContainer>
        <DefaultWidthContainer>
            <ImageAndTextContainer
                ingress="Services"
                image={{
                    src: '/images/ronny.webp',
                    alt: '',
                    maxWidth: 415,
                    maxHeight: 530,
                }}
                extraClassNames={styles.headerContainer}
            >
                <div className={styles.smallText}>
                    We offer a range of professional services to complement our Noria Insurance
                    Software. These include:
                </div>
                <ul className={styles.list}>
                    <li>Customer support</li>
                    <li>24/7 availability</li>
                    <li>Implementation support</li>
                    <li>Migration & Conversion</li>
                    <li>Upgrade Service</li>
                    <li>Training</li>
                </ul>
            </ImageAndTextContainer>
        </DefaultWidthContainer>
        <CustomersInsurance />
        <ContactBannerComponent heading={'Questions about Insurance Solutions?'} isPlural={true}>
            {
                <>
                    <div>
                        <p>Ronny Reppe - Commercial</p>
                        <a href="mailto:ronny.reppe@noria.no?subject=Queries/Meeting - Insurance Solutions&body=Hi, Ronny Reppe">
                            Contact Ronny
                        </a>
                    </div>
                </>
            }
        </ContactBannerComponent>
    </>
);

export default InsurancePageComponent;
